import { Link, useParams } from 'react-router-dom'
import { useInvoiceDoc } from '../orders/useOrders'
import { BillingDocument, snapshotDocModel } from './BillingDocument'

/**
 * Beleg-Ansicht eines EINZELNEN Ledger-Belegs (Route /print/invoice-doc/:invoiceId, auth-gated, ohne App-
 * Shell) — für die Rechnungsliste: eine bestimmte Rechnung ODER Stornorechnung ansehen/drucken, auch eine
 * bereits stornierte Original­rechnung. Rein lesend aus dem eingefrorenen Snapshot; Festschreiben/Storno
 * laufen ausschließlich über den Auftrag (/print/invoice/:id).
 */
export function InvoiceDocPage() {
  const { invoiceId: param } = useParams()
  const id = Number(param)
  const { data, isLoading, error } = useInvoiceDoc(id)

  if (isLoading) return <div className="muted">Beleg wird geladen…</div>
  if (error || !data) {
    return (
      <div className="error" role="alert">
        Beleg konnte nicht geladen werden.
      </div>
    )
  }

  return (
    <main className="wf-print" data-theme="light">
      <div className="wf-print__bar">
        <Link to="/invoices" className="wf-btn wf-btn--ghost">
          ← Zurück
        </Link>
        <div className="wf-print__baractions">
          <button type="button" className="wf-btn wf-btn--primary" onClick={() => window.print()}>
            Drucken / als PDF
          </button>
        </div>
      </div>
      <BillingDocument model={snapshotDocModel(data.invoice)} />
    </main>
  )
}
